import { useContext } from "react"
import { SidebarContentContext } from "../context/sidebarContentContext"

export default function useSidebarContent() {
  const contextValue = useContext(SidebarContentContext)

  if (!contextValue) {
    throw new Error("useSidebarContent must be used within SidebarContentProvider")
  }

  return contextValue
}
